import { mapState, mapMutations } from "vuex";
import { EVENTS } from "@/utils";
import AppDropdown from "@/components/AppDropdown";
import AppButton from "@/components/AppButton";
import AppIcon from "@/components/AppIcon";
import FlexRow from "@/components/FlexRow.vue";
import SellerFilter from "@/components/new-filters/SellerFilter.vue";
import SegmentFilter from "@/components/new-filters/SegmentFilter.vue";
import AccountsMixin from "@/mixins/AccountsMixin.vue";
import InitializeFiltersMixin from "@/mixins/InitializeFiltersMixin";
import LiteTableMixin from "@/mixins/LiteTableMixin.vue";
import ProductFilter from "@/components/new-filters/ProductFilter.vue";
import MarketplaceFilter from "@/components/new-filters/MarketplaceFilter.vue";
import EmptySegments from "@/components/EmptySegments.vue";
export default {
  name: "ProductDataTopSection",
  mixins: [AccountsMixin, InitializeFiltersMixin, LiteTableMixin],
  components: {
    AppDropdown,
    AppButton,
    AppIcon,
    FlexRow,
    SellerFilter,
    SegmentFilter,
    ProductFilter,
    MarketplaceFilter,
    EmptySegments
  },
  props: {
    selected: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      //item: "metric",
      options: [{
        value: "imperial",
        text: "Imperial"
      }, {
        value: "metric",
        text: "Metric"
      }],
      sellers: []
    };
  },
  async created() {
    //console.log("[product data top section created.. changing dropdown]");
  },
  async mounted() {
    //console.log("[product data top section mounted]");
  },
  computed: {
    ...mapState({
      sellers_filter: state => state.product_data.sellers_filter,
      segments_filter: state => state.product_data.segments_filter,
      marketplaces_filter: state => state.product_data.marketplaces_filter,
      products_filter: state => state.product_data.products_filter,
      current_workspace: state => state.workspace.current_workspace,
      item: state => state.workspace.scaleType
    })
  },
  methods: {
    ...mapMutations(["productDataSellersFilterSet", "productDataProductsFilterSet", "productDataKeywordsListSet"]),
    async applySellers() {
      if (this.sellers_filter.isModified) {
        this.sellers_filter.apply();
        this.products_filter.clearAndApply();
        this.segments_filter.clearAndApply();
        window.$bus.trigger("showSuccess", {
          message: "⏳Fetching sub filters for sellers...  ",
          visible: true,
          delay: 10
        });
        await window.$bus.trigger(EVENTS.REFRESH_PRODUCT_DATA_SELLERS_SUB_FILTERS);
        window.$bus.trigger("showSuccess", {
          visible: false,
          message: ""
        });
        await window.$bus.trigger(EVENTS.REFRESH_PRODUCT_DATA_PAGE);
      }
    },
    async clearSellers() {
      if (this.sellers_filter.isModified) {
        //console.log("[clear sellers called]");
        this.sellers_filter.clear();
        window.$bus.trigger("showSuccess", {
          message: "⏳Refreshing ...  ",
          visible: true,
          delay: 10
        });
        await window.$bus.trigger(EVENTS.REFRESH_PRODUCT_DATA_PAGE);
      }
    },
    applyProducts() {
      if (this.products_filter.isModified) {
        this.products_filter.apply();
        window.$bus.trigger(EVENTS.REFRESH_PRODUCT_DATA_PAGE);
      }
    },
    async searchProducts($event) {
      this.products_filter.searching = true;
      if (Array.isArray($event) && $event.length === 0) {
        this.products_filter.searching = false;
      }
      this.productDataKeywordsListSet($event);
      await window.$bus.trigger(EVENTS.REFRESH_PRODUCT_DATA_SUGGESTION_PAGE);
    },
    async handleScaleTypeChange(newScaleType) {
      //console.log("[selected scale option]:", newScaleType);
      await window.$bus.trigger(EVENTS.CHANGE_PRODUCT_DATA_SCALE, newScaleType);
    },
    async applySegments() {
      if (this.segments_filter.isModified) {
        this.segments_filter.apply();
        window.$bus.trigger('showSuccess', {
          message: '⏳Fetching product filters for segments...  ',
          visible: true,
          delay: 50
        });
        await window.$bus.trigger(EVENTS.REFRESH_PRODUCT_DATA_PRODUCTS_SUB_FILTERS);
        window.$bus.trigger(EVENTS.REFRESH_PRODUCT_DATA_PAGE);
      }
    },
    async handleProductsCleared() {
      window.$bus.trigger("showSuccess", {
        message: "⏳Refreshing...  ",
        visible: true,
        delay: 10
      });
      await window.$bus.trigger(EVENTS.REFRESH_PRODUCT_DATA_PAGE);
    },
    handleErrorOccured() {
      //console.log("[no account]");
      //this.announceNoAccounts();
    }
  }
};